import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { buildBookingConfirmationEmail } from "@/utils/bookingConfirmationEmail";
import { useToast } from "@/services/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingConfirmationEmail',
  props: {
    booking: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const { showToast } = useToast();

const dialog = ref(false);
const recipient = ref("");
const subject = ref("");
const body = ref("");

const resetTemplate = () => {
  const template = buildBookingConfirmationEmail(props.booking);
  recipient.value = props.booking.userEmail ?? "";
  subject.value = template.subject;
  body.value = template.body;
};

const openDialog = () => {
  resetTemplate();
  dialog.value = true;
};

const copy = async (text: string, message: string) => {
  try {
    await navigator.clipboard.writeText(text);
    showToast(message);
  } catch {
    showToast("A másolás nem sikerült, jelöld ki a szöveget kézzel", "error");
  }
};

const __returned__ = { props, showToast, dialog, recipient, subject, body, resetTemplate, openDialog, copy, ref, get buildBookingConfirmationEmail() { return buildBookingConfirmationEmail }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})